/* VorixHouse — popup promocional de temporada.
   Se muestra una vez por sesión y campaña, unos segundos después de entrar. Sin dependencias. */
(function () {
  'use strict';

  function seen(key) {
    try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; }
  }
  function mark(key) {
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
  }
  /* No se abre encima de otra ventana (formulario de compra, carrito lateral, menú, lightbox). */
  function busy() {
    return document.body.classList.contains('overflow-hidden') ||
      !!document.querySelector('.drawer.active, modal-dialog[open], product-modal[open], details[open] > .menu-drawer');
  }

  function setup(root) {
    if (root.dataset.vxReady) return;
    root.dataset.vxReady = '1';

    var key = 'vx-pop:' + (root.dataset.key || 'default');
    var delay = Number(root.dataset.delay) || 3000;
    var closeBtn = root.querySelector('[data-vx-pop-close]');
    var cta = root.querySelector('[data-vx-pop-cta]');
    var img = root.querySelector('img');
    var lastFocus = null;
    var tries = 0;

    function onKey(e) { if (e.key === 'Escape') close(); }

    function open(force) {
      if (!force && busy()) {
        if (++tries <= 5) setTimeout(open, 4000);
        return;
      }
      mark(key);
      lastFocus = document.activeElement;
      root.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
      document.addEventListener('keydown', onKey);
      if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
    }

    function close() {
      if (root.hidden) return;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { root.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    /* Clic fuera de la tarjeta (sobre el fondo oscurecido). */
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    if (cta) {
      cta.addEventListener('click', function (e) {
        var same = false;
        try { same = new URL(cta.href, location.href).pathname === location.pathname; } catch (err) {}
        close();
        /* Si ya está en el producto de la oferta, basta con cerrar. */
        if (same) e.preventDefault();
      });
    }

    /* Editor del theme: se muestra al seleccionar la sección, sin esperar ni recordar la sesión. */
    if (window.Shopify && window.Shopify.designMode) {
      var section = root.closest('.shopify-section');
      if (section) {
        section.addEventListener('shopify:section:select', function () { if (img) img.loading = 'eager'; open(true); });
        section.addEventListener('shopify:section:deselect', close);
      }
      return;
    }

    if (seen(key)) return;
    /* La imagen se descarga mientras corre la espera, para que el popup aparezca ya completo. */
    if (img) img.loading = 'eager';
    /* La espera solo corre con la página a la vista. En móvil es habitual abrir la tienda y pasar a otra
       app (o tenerla en una pestaña de fondo): si el aviso «se abriera» ahí, quedaría marcado como visto
       para toda la sesión sin que nadie lo viera. */
    function whenVisible(fn) {
      if (document.visibilityState !== 'hidden') return fn();
      document.addEventListener('visibilitychange', function wait() {
        if (document.visibilityState === 'hidden') return;
        document.removeEventListener('visibilitychange', wait);
        fn();
      });
    }
    function start() {
      whenVisible(function () {
        setTimeout(function () {
          if (document.visibilityState === 'hidden') return start();
          open();
        }, delay);
      });
    }
    start();
  }

  function init() {
    document.querySelectorAll('[data-vx-pop]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
